import { WithULRpcCaller } from './WithULRpcCaller';

export const DefaultULRpcCaller = WithULRpcCaller(Object);
